export default __webpack_public_path__ + "static/media/servico3.e67ad9dd.jpg";